/* eslint-disable */

import '@fancyapps/fancybox/dist/jquery.fancybox';

/////////////////////////////////////////////
////// Functions to manipulate cookies //////
/////////////////////////////////////////////
// cookie setter
function setCookie(cname, cvalue, exdays) {
 const d = new Date();
 d.setTime(d.getTime() + (exdays * 24 * 60 * 60 * 1000));
 const expires = `expires=${d.toUTCString()}`;
 document.cookie = `${cname}=${cvalue};${expires};path=/`;
}

// cookie getter
function getCookie(cname) {
  var name = cname + "=";
  var ca = document.cookie.split(';');
  for(var i = 0; i < ca.length; i++) {
    var c = ca[i];
    while (c.charAt(0) == ' ') {
      c = c.substring(1);
    }
    if (c.indexOf(name) == 0) {
      return c.substring(name.length, c.length);
    }
  }
  return "";
}

function debounce(func, wait, immediate) {
  let timeout;
  return function() {
    const context = this;
    const args = arguments;
    const later = () => {
      timeout = null;
      if (!immediate) func.apply(context, args);
    };
    const callNow = immediate && !timeout;
    clearTimeout(timeout);
    timeout = setTimeout(later, wait);
    if (callNow) func.apply(context, args);
  };
}

// jQuery plugin for changing an element's type (change <div> into <a> and keep attributes)
(($ => {
   $.fn.changeElementType = function(newType) {
       const attrs = {};

       $.each(this[0].attributes, (idx, attr) => {
           attrs[attr.nodeName] = attr.nodeValue;
       });


       this.replaceWith(function() {
           return $(`<${newType}/>`, attrs).append($(this).contents());
       });
   };
}))(jQuery);

function notification(message, success) {
  jQuery("#epionce-global-notification").remove();
  let styleClass = 'success';
  let timeoutLength = 5500;
  if (success !== true) {
  styleClass = 'failure';
  timeoutLength = 8500;
  }
  const html = `<div id="epionce-global-notification" class="global-notification ${styleClass}"><p>${message}</p></div>`;
  jQuery('body').append(html);

  setTimeout(() => {
  jQuery("#epionce-global-notification").addClass('in-view');
  },500);

  setTimeout(() => {
   jQuery("#epionce-global-notification").removeClass('in-view');
   setTimeout(() => {
     jQuery("#epionce-global-notification").remove();
   },500);
  },timeoutLength);
}

export default {
  init() {
    if (typeof sentry_settings !== "undefined") {
      Sentry.init(sentry_settings);
    }

    // JavaScript to be fired on all pages
    // String.prototype.toProperCase = function () {
    //   return this.replace(/\w\S*/g, txt => txt.charAt(0).toUpperCase() + txt.substr(1).toLowerCase());
    // };

    // function strToProper(object) {
    //   let string = object.val();
    //   string = string.toProperCase();
    //   return object.val(string);
    // }

    // Browser support for Array.from();
    if (!Array.from) {
      console.log('Browser does not support Array.from() by default. Using Custom polyfill..');
      Array.from = ((() => {
        const toStr = Object.prototype.toString;
        const isCallable = fn => typeof fn === 'function' || toStr.call(fn) === '[object Function]';
        const toInteger = value => {
          const number = Number(value);
          if (isNaN(number)) { return 0; }
          if (number === 0 || !isFinite(number)) { return number; }
          return (number > 0 ? 1 : -1) * Math.floor(Math.abs(number));
        };
        const maxSafeInteger = 2 ** 53 - 1;
        const toLength = value => {
          const len = toInteger(value);
          return Math.min(Math.max(len, 0), maxSafeInteger);
        };

        // The length property of the from method is 1.
        return function from(arrayLike/*, mapFn, thisArg */) {
          // 1. Let C be the this value.
          const C = this;

          // 2. Let items be ToObject(arrayLike).
          const items = Object(arrayLike);

          // 3. ReturnIfAbrupt(items).
          if (arrayLike == null) {
            throw new TypeError("Array.from requires an array-like object - not null or undefined");
          }

          // 4. If mapfn is undefined, then let mapping be false.
          const mapFn = arguments.length > 1 ? arguments[1] : void undefined;
          let T;
          if (typeof mapFn !== 'undefined') {
            // 5. else
            // 5. a If IsCallable(mapfn) is false, throw a TypeError exception.
            if (!isCallable(mapFn)) {
              throw new TypeError('Array.from: when provided, the second argument must be a function');
            }

            // 5. b. If thisArg was supplied, let T be thisArg; else let T be undefined.
            if (arguments.length > 2) {
              T = arguments[2];
            }
          }

          // 10. Let lenValue be Get(items, "length").
          // 11. Let len be ToLength(lenValue).
          const len = toLength(items.length);

          // 13. If IsConstructor(C) is true, then
          // 13. a. Let A be the result of calling the [[Construct]] internal method of C with an argument list containing the single item len.
          // 14. a. Else, Let A be ArrayCreate(len).
          const A = isCallable(C) ? Object(new C(len)) : new Array(len);

          // 16. Let k be 0.
          let k = 0;
          // 17. Repeat, while k < len… (also steps a - h)
          let kValue;
          while (k < len) {
            kValue = items[k];
            if (mapFn) {
              A[k] = typeof T === 'undefined' ? mapFn(kValue, k) : mapFn.call(T, kValue, k);
            } else {
              A[k] = kValue;
            }
            k += 1;
          }
          // 18. Let putStatus be Put(A, "length", len, true).
          A.length = len;
          // 20. Return A.
          return A;
        };
      })());
    }

    const userFieldsArray = [
      $('#billing_first_name'),
      $('#billing_last_name'),
      $('#shipping_first_name'),
      $('#shipping_last_name'),
      $('#billing_address_1'),
      $('#billing_city'),
      $('#userFirstName'),
      $('#userLastName'),
      $('#userBillingAddress1'),
      $('#userBillingCity'),
      $('#userShippingAddress1'),
      $('#userShippingCity'),
      $('#billing-first-name'),
      $('#billing-last-name'),
      $('#shipping-first-name'),
      $('#shipping-last-name'),
    ];

    // userFieldsArray.forEach((e) => {
    //   $(e.selector).keyup(function() {
    //     strToProper($(this));
    //   });
    // });

    function saveProCodeFromUrl(paramSeparator) {
      var professionalCode = window.location.href.split(`${paramSeparator}a=`)[1];

      // split off any other parameters that might
      // be appended after the professionalCode in the URL
      if ( professionalCode.includes('&') ) {
        professionalCode = professionalCode.split('&')[0];
      }

      // const epionce_near_you = [];
      const $promise = $.ajax({
        url: epionce_near_you.ajaxUrl,
        method: 'post',
        dataType: 'json',
        data: {'json': {'professionalCode': professionalCode}, 'security': epionce_near_you.nonce, 'action': 'saveProfessionalCodeToUserAccount'}
      });

      $promise.done((response, textStatus, jqXhr) => {
        if (response.status === 'fail') {
          notification('The link you used includes a code that is<br>not associated with any Epionce providers.', false);
        } else {
          notification('Professional successfully saved<br>to your account!', true);
        }
      });

      $promise.fail((jqXhr, textStatus, errorThrown) => {
        console.log(jqXhr);
        console.log(textStatus);
        console.log(errorThrown);
      });
    }

    // grab pro code from URL, if one is present
    if ( window.location.href.includes('&a=') ) {
      saveProCodeFromUrl('&');
    } else if ( window.location.href.includes('?a=') ) {
      saveProCodeFromUrl('?');
    }


    $('.select').selectpicker({
      width: '100%',
    });

    const cartTotal = cartInfo.cartTotal;
    const cartUrl = cartInfo.cartUrl;
    const shoppingCartIcon = `<li id="menu-item-142" class="menu-item menu-item-type-post_type menu-item-object-page menu-item-142 main-nav-shopping-cart-button"><a href="${cartUrl}">${cartTotal}</a></li>`;
    const lastMainNavChild = $('.header__main-nav__list').append(shoppingCartIcon);


    // mobile utility nav search toggle event handler
    $('.header__utility-nav__search-submit--collapsed, .header__utility-nav__search-submit--collapsed--mobile').on('click', e => {
      e.preventDefault();

      if ($('.header__utility-nav__search-field--mobile, .header__utility-nav__search-field').hasClass('active')) {
        // already open, collapse and change icon to a search symbol
        $('.header__utility-nav__search-field--mobile, .header__utility-nav__search-field').removeClass('active');
        $('.header__utility-nav__search-submit--collapsed, .header__utility-nav__search-submit--collapsed--mobile').html('<i class="far fa-search"></i>');
      } else {
        // not open, add the active class and change icon to a close symbol
        $('.header__utility-nav__search-field--mobile, .header__utility-nav__search-field').addClass('active');
        $('.header__utility-nav__search-submit--collapsed, .header__utility-nav__search-submit--collapsed--mobile').html('<i class="far fa-close"></i>');
      }
    });



    // add the cart item count to the mobile menu
    $('.header__mobile-menu__list-item.shopping-cart-button > a').text(cartTotal).attr('href', cartUrl);

    // toggle the search input slide down on mobile
    $('.header__mobile-menu__search-toggle').on('click',function(e){
      e.preventDefault();

      if ($(this).find('.fa-search').length) {
        // replace search icon with close icon
        $(this).find('.fa-search').addClass('fa-close').removeClass('fa-search');
      } else {
        // replace close icon with search icon
        $(this).find('.fa-close').addClass('fa-search').removeClass('fa-close');
      }

      $(this).toggleClass('search-active');
      $('.header__full-width-slide-down__wrapper--search').toggleClass('active');
      $('.header__mobile-menu__list').toggleClass('search-active');
      $('.header__logo').toggleClass('search-active');
      $('.header__logo--mobile--phone--xs').toggleClass('search-active');
    });



    // toggle the mobile nav slide in menu
    $('.header__mobile-menu__toggle').on('click',function(e){
      e.preventDefault();

      $('body, html').toggleClass('html-overflow');

      $('.header__main-nav__mobile-slide-in__wrapper').toggleClass('active');
        $(this).toggleClass('menu-active');

      $('.header__wrapper').toggleClass('wrapper-active');

      if ($('.header__main-nav__mobile-slide-in__wrapper').hasClass('active')) {
        // sliding into the viewport
        $(this).find('.fa').addClass('fa-close').removeClass('fa-bars');
        const headerHeight = $('.header__wrapper').height();
        $('.header__main-nav__mobile-slide-in__wrapper').css({"top":`${headerHeight}px`});
      } else {
        $(this).find('.fa').addClass('fa-bars').removeClass('fa-close');
      }
    });



    // toggle the mobile phone xs sales marquee
    $('.header__utility-nav__cta-toggle--mobile--phone--xs').on('click',e => {
      e.preventDefault();
      $('.header__full-width-slide-down__wrapper--sales').toggleClass('active');

      $(() => {
        if ($('.header__full-width-slide-down__wrapper--sales').hasClass('active')) {
          // initialize slick slider for xs mobile phone sales list
          $('.header__full-width-slide-down__list--sales').slick({
            infinite: true,
            speed: 700,
            autoplay:true,
            autoplaySpeed: 5000,
            arrows:false,
          });

          // Unhide slider once slick is loaded
          $('.header__full-width-slide-down__list--sales').css("opacity", "1");
        }
      });
    });

    $(() => {
      $('.header__utility-nav__slider-container').slick({
        infinite: true,
        speed: 700,
        autoplay:true,
        autoplaySpeed: 5000,
        arrows:false,
        vertical: true,
      });

      // Unhide slider once slick is loaded
      $('.header__utility-nav__slider-container').css("opacity", "1");
    });

    // Set the heights of the magazine article teasers, if that section is present
    if ($('.featured-articles__wrapper').length) {
      $(window).load(e => {
        e.preventDefault();
        const $mainLeft = $('.featured-articles__column--main-left');
        const $subRightTop = $('.featured-articles__column--sub-right-top');
        const $subRightBottomLeft = $('.featured-articles__column--sub-right-bottom-left');
        const $subRightBottomRight = $('.featured-articles__column--sub-right-bottom-right');

        const mainLeftWidth = $mainLeft.width();
        const subRightTopWidth = $subRightTop.width();

        $mainLeft.height(mainLeftWidth);
        $subRightTop.height(subRightTopWidth/2);
        $subRightBottomLeft.height(subRightTopWidth/2);
        $subRightBottomRight.height(subRightTopWidth/2);
      });
    }



    // initialize a slick slider for the testimonial section, if it's present
    $('.testimonials__slider-container').slick({
      adaptiveHeight:true,
      infinite: true,
      speed: 700,
      autoplay:true,
      autoplaySpeed: 8000,
      pauseOnHover: true,
      'prevArrow':'<button type="button" class="slick-prev"><i class="far fa-angle-left"></i></button>',
      'nextArrow': '<button type="button" class="slick-next"><i class="far fa-angle-right"></i></button>',
    });

    // initialize a slick slider for the testimonial section, if it's present
    $('.product-detail__testimonial-slider').slick({
      'prevArrow':'<button type="button" class="slick-prev"><i class="far fa-angle-left"></i></button>',
      'nextArrow': '<button type="button" class="slick-next"><i class="far fa-angle-right"></i></button>',
      adaptiveHeight:true,
    });



    // search page checkboxes
    if ( $('.search-results-page__filter-checkbox').length ) {
      const checkboxes = [];

      // get already saved cookie
      const searchResultsPreferencesCookie = getCookie('searchResultsPreferences');

      // check if there was a previous cookie stored
      if (!searchResultsPreferencesCookie.length) {

        // basically just grabs all of the checkboxes since they are all checked by default
        $('.search-results-page__filter-checkbox:checked').each(function(i,e){
          checkboxes[i] = $(this).val();
        });

        // create cookie for a year
        setCookie("searchResultsPreferences", checkboxes.join(','), 365);

      } else {

        // already have a cookie saved, get the values
        const searchResultsPreferencesCookieArray = searchResultsPreferencesCookie.split(',');

        // unset all checkboxes
        $('.search-results-page__filter-checkbox').prop("checked", false);

        // set the checkboxes
        searchResultsPreferencesCookieArray.forEach(e => {
          $(`.search-results-page__filter-checkbox[value=${e}]`).prop("checked", true);
        });
      }

      // event handler for filter checkbox clicks
      $('.search-results-page__filter-checkbox').on('change',e => {
        e.preventDefault();
        const checkboxes = [];

        //
        $('.search-results-page__filter-checkbox:checked').each(function(i,e){
          checkboxes[i] = $(this).val();
        });

        // put checkbox info in object for better json/ajax support
        const checkboxJson = {};
        checkboxJson.searchResults = checkboxes.join(',');

        // set cookie for a year
        setCookie("searchResultsPreferences", checkboxJson.searchResults, 365);

        // const searchPage = [];
        $.ajax({
          url: search_page.ajaxUrl,
          method: 'POST',
          dataType: 'json',
          data: {'json': checkboxJson, 'action': 'update_user_search_preferences', 'security': search_page.nonce},
          success(data, textStatus, jqXhr) {
            if (data.status === 'success') {
              location.reload();
            }
          },
          error(jqXhr, textStatus, errorThrown) {
            console.log(textStatus);
          },
        });
      });
    }

    //Number spinner on product detail pages and quick view popups across site
    let numberSpinnerAction;
    $(".number-spinner button").click(function () {
        const btn = $(this);
        const input = btn.closest('.number-spinner').find('input');
        btn.closest('.number-spinner').find('button').prop("disabled", false);

      if (btn.attr('data-dir') == 'up') {
        if ( input.attr('max') == undefined || parseInt(input.val()) < parseInt(input.attr('max')) ) {
            input.val(parseInt(input.val())+1);
        }else{
            btn.prop("disabled", true);
            clearInterval(numberSpinnerAction);
        }
      } else {
        if ( input.attr('min') == undefined || parseInt(input.val()) > parseInt(input.attr('min')) ) {
            input.val(parseInt(input.val())-1);
        }else{
            btn.prop("disabled", true);
            clearInterval(numberSpinnerAction);
        }
      }
    });

    const badgeIdBase = 'badge-';
    const badgeCount = $(`[id^="${badgeIdBase}"]`).length;
    const paddingLeft = 5;
    for (let i = 0; i <= badgeCount; i++) {
      if ( i === 0 ) {
        $(`#badge-${i}`).css({'top':'-1px', 'left':'15px'});
      } else {
        const prevLeft = parseInt($(`#badge-${i-1}`).css('left'));
        const prevWidth = parseInt($(`#badge-${i-1}`).outerWidth());
        $(`#badge-${i}`).css({'top':'-1px', 'left':`${prevLeft+prevWidth+paddingLeft}px`});
      }
    }


    const $win = $(window);

    $('.masthead__wrapper').append('<div class="loading-icon" style="width:100%;height:120px;position:relative;"><i class="far fa-spinner fa-pulse fa-2x" style="position:absolute;top:50%;color:#696060;left:50%;transform:translate3d(-50%,-50%,0);"></i></div>');


    $win.on('load', () => {
      $('.masthead__container').css({"opacity":"1", "height":"auto"});
      if ( $('.loading-icon').length ) {
        $('.loading-icon').fadeOut(200).remove();
      }
    });

    $('.masthead__slider-container').slick({
      autoplay: true,
      adaptiveHeight: false,
      responsive: [
        {
          breakpoint: 544,
          settings: {
            adaptiveHeight: true,
          },
        },
      ],
      autoplaySpeed: 8000,
      speed: 300,
      fade: true,
      cssEase: 'linear',
      arrows: false,
      // 'prevArrow':'<button type="button" class="slick-prev"><i class="far fa-angle-left fa-2x"></i></button>',
      // 'nextArrow': '<button type="button" class="slick-next"><i class="far fa-angle-right fa-2x"></i></button>',
    });
    
    // Main slider
    $('.custom-slider .product-slider').slick({
      slidesToShow: 1,
      slidesToScroll: 1,
      arrows: true,
      fade: true,
      prevArrow: '<button type="button" class="custom-prev"><i class="fa fa-chevron-left"></i></button>',
      nextArrow: '<button type="button" class="custom-next"><i class="fa fa-chevron-right"></i></button>',
      swipe: true,
      touchMove: true,
      draggable: true
    });
    
    // Thumbnail click event
    $('.custom-slider .product-thumbs img').on('click', function() {
      var index = $(this).data('index');
      $('.custom-slider .product-slider').slick('slickGoTo', index);
    
      $('.custom-slider .product-thumbs img').removeClass('active');
      $(this).addClass('active');
    });
    
    // Update active thumbnail on slide change
    $('.custom-slider .product-slider').on('afterChange', function(event, slick, currentSlide) {
      $('.custom-slider .product-thumbs img').removeClass('active');
      $('.custom-slider .product-thumbs img[data-index="' + currentSlide + '"]').addClass('active');
    });
    
    // Initialize Fancybox
    $('[data-fancybox="gallery"]').fancybox({
      buttons: ['slideShow', 'fullScreen', 'thumbs', 'close'],
    });

    const colorSettings = [];
    const backgroundImageSettings = [];

    $("div[class*='masthead__row--']").each( function(i) {
      const color = $(this).attr('data-color');
      colorSettings.push(color);

      const bgImage = $(this).attr('data-bgimage');
      backgroundImageSettings.push(bgImage);
    });

    const changeColor = slide => {
      $('.masthead__wrapper').css("background-color", colorSettings[slide]);
    }

    const changeImage = slide => {
      $('.masthead__wrapper').css("background-image", `url('${backgroundImageSettings[slide]}')`);
    }

    // Change next slide color/image before change
    $('.masthead__slider-container').on('beforeChange', (event, slick, currentSlide, nextSlide) => {
      backgroundImageSettings.forEach(backgroundImageSetting => {
        if (backgroundImageSetting === undefined) {
          changeColor(nextSlide);
        } else {
          changeImage(nextSlide);
        }
      });
    });


    /*
    // BACKGROUND COLOR DECECTION
    // Detect if the __wrapper background-color is either
    // light or dark and apply the appropriate
    // class.
    */

    // $.fn.colorBrightness = function(){
    //   function getBackgroundColor($el) {
    //     console.log($el);
    //     let bgColor = "";
    //     while($el[0].tagName.toLowerCase() != "html") {
    //       bgColor = $el.css("background-color");
    //       if(bgColor != "rgba(0, 0, 0, 0)" && bgColor != "transparent") {
    //         break;
    //       }
    //       $el = $el.parent();
    //     }
    //     return bgColor;
    //   }

    //   let r;
    //   let g;
    //   let b;
    //   let brightness;
    //   let color = getBackgroundColor(this);

    //   if (color.match(/^rgb/)) {
    //     color = color.match(/rgba?\(([^)]+)\)/)[1];
    //     color = color.split(/ *, */).map(Number);
    //     r = color[0];
    //     g = color[1];
    //     b = color[2];
    //   } else if ('#' == color[0] && 7 == color.length) {
    //     r = parseInt(color.slice(1, 3), 16);
    //     g = parseInt(color.slice(3, 5), 16);
    //     b = parseInt(color.slice(5, 7), 16);
    //   } else if ('#' == color[0] && 4 == color.length) {
    //     r = parseInt(color[1] + color[1], 16);
    //     g = parseInt(color[2] + color[2], 16);
    //     b = parseInt(color[3] + color[3], 16);
    //   }

    //   brightness = (r * 299 + g * 587 + b * 114) / 1000;

    //   if (brightness < 125) {
    //     // white text
    //     this.removeClass("light").addClass("dark");
    //   } else {
    //     // black text
    //     this.removeClass("dark").addClass("light");
    //   }
    //   return this;
    // };

    // Woocommerce Free Gift
    const wfg_checkbox = $('.wfg-checkbox');

    // Disable Add free gift
    $('.wfg-add-gifts').attr('disabled', 'disabled');
    $('.wfg-gift-item').after('<div class="add-item-alert" style="text-align:center; padding:5px 15px; color:#373a3c; width:230px;"><i>*Select a free gift by checking the box and choosing "Add Free Sample"</i></div>');

    wfg_checkbox.click(function() {
      if ($(this).is(':checked')) {
        $('.wfg-add-gifts').removeAttr('disabled');
        $('.add-item-alert').fadeOut(200).remove();
      } else {
        $('.wfg-gift-item').after('<div class="add-item-alert" style="text-align:center; padding:5px 15px; color:#373a3c; width:230px;"><i>*Select a free gift by checking the box and choosing "Add Free Sample"</i></div>');
        $('.wfg-add-gifts').attr('disabled', 'disabled');
      }
    });

    (($ => {
      $('.timeline__event--small span').mouseover(() => {
        $('.timeline__event--small__tooltip').show();
      });
      $('.timeline__event--small span').mouseout(() => {
        $('.timeline__event--small__tooltip').hide();
      });
    }))


    // Product QUICK View
    // add the event handler for the Quickview buttons
    $('[id^="quickview-button_"]').on('click', e => {
      e.preventDefault();
      e.stopPropagation();
      const target = e.target || e.srcElement;
      const productId = $(target).attr('id').split('_')[1];
      const $modal = $('#quickviewModal');

      // update the value of the data-product-id attr on the modal
      $modal.attr('data-product-id', productId);

      // hide the modal content and show loader
      $modal.find('.product-detail__wrapper--quickview-modal').addClass('hidden').before('<div style="text-align:center;"><i id="productModalLoader" class="far fa-spinner fa-pulse fa-4x"></i></div>');

      // show the modal
      $('#quickviewModal').modal({"show":true});
    });

    // event handler for the modal show event
    $('#quickviewModal').on('show.bs.modal',e => {
      const modal = e.target || e.srcElement;
      const productId = $(modal).attr('data-product-id');
      const jsonData = {
        productId
      };

      // perform an AJAX request to get the products info
      const $promise = $.ajax({
        url: products.ajaxUrl,
        method: 'post',
        dataType: 'json',
        data: {'json': jsonData, 'security': products.nonce, 'action': 'getProductDetails'}
      });

      $promise.done((response, textStatus, jqXhr) => {
        const productModalClasses = {
          flagContainer: 'product-detail__status',
          image: 'product-detail__image--quickview-modal',
          title: 'product-detail__title--quickview-modal',
          size: 'product-detail__details__size',
          priceContainer: 'product-detail__details__price--quickview-modal',
          shopActionsContainer: 'product-detail__details__shop-actions.quickview-modal',
          addToBagContainer: 'product-detail__details__shop-actions__add-to-bag--quickview-modal',
          buyNowContainer: 'product-detail__details__shop-actions__buy-now--quickview-modal',
          description: 'product-detail__details__description',
          viewAllDetailsLink: 'product-detail__details__shop-actions__view-all-details__link--quickview-modal'
        };

        let badgeCount = 0;
        let newFlag;
        if (response.data.isNew) {
          newFlag = `<span id="quickview-badge-${badgeCount}" class="product-detail__status--new"></span>`;
          badgeCount++;
        } else {
          newFlag = '';
        }
        let soldOutFlag;
        if (!response.data.isInStock) {
          soldOutFlag = `<span id="quickview-badge-${badgeCount}" class="product-detail__status--sold-out"></span>`;
          badgeCount++;
        } else {
          soldOutFlag = '';
        }
        /**
         * Comment out pro pricing 2020-10-22 per Trish's request
         */
        if (products.userRole === 'pro') {
          // show the pro pricing table
          // $('.product-detail__details__pro-pricing-table-container').removeClass('hidden');

          // var regularPrice = `<span class="regular-price" data-original-price="${response.data.regularPrice}">$${(parseFloat(response.data.regularPrice)-(parseFloat(response.data.regularPrice)*0.50)).toFixed(2)}</span>`;

          // // populate the pro pricing table with regular price tier data
          // $('#pro-price-tier-1').html(`$${(response.data.regularPrice-(response.data.regularPrice*0.50)).toFixed(2)}`);
          // $('#pro-price-tier-2').html(`$${(response.data.regularPrice-(response.data.regularPrice*0.55)).toFixed(2)}`);
          // $('#pro-price-tier-3').html(`$${(response.data.regularPrice-(response.data.regularPrice*0.575)).toFixed(2)}`);
          // var saleFlag;
          // var salePrice = '';
          // if (response.data.isOnSale) {
          //   saleFlag = `<span id="quickview-badge-${badgeCount}" class="span product-detail__status--sale"></span>`;
          //   salePrice = `<span class="sale-price" data-original-price="${response.data.salePrice}">$${(parseFloat(response.data.salePrice)-(parseFloat(response.data.salePrice)*0.50)).toFixed(2)}</span>`;

          //   // populate the pro pricing table with sale price tier data
          //   $('#pro-price-tier-1').html(`$${(response.data.salePrice-(response.data.salePrice*0.50)).toFixed(2)}`);
          //   $('#pro-price-tier-2').html(`$${(response.data.salePrice-(response.data.salePrice*0.55)).toFixed(2)}`);
          //   $('#pro-price-tier-3').html(`$${(response.data.salePrice-(response.data.salePrice*0.575)).toFixed(2)}`);
          // } else {
          //   saleFlag = '';
          //   salePrice = '';
          // }
        } else {
          var regularPrice = `<span class="regular-price" data-original-price="${response.data.regularPrice}">$${response.data.regularPrice}</span>`;
          var saleFlag;
          var salePrice = '';
          if (response.data.isOnSale) {
            saleFlag = `<span id="quickview-badge-${badgeCount}" class="span product-detail__status--sale"></span>`;
            salePrice = `<span class="sale-price" data-original-price="${response.data.salePrice}">$${response.data.salePrice}</span>`;
            badgeCount++;
          } else {
            saleFlag = '';
            salePrice = '';
          }
        }

        // Quantity select reset
        $('#number-spinner-input').val(1);

        const addToBagButton = `<a href="#" class="product-detail__details__shop-actions__add-to-bag__btn" data-product-id="${response.data.productId}">Add to Bag</a>`;
        const buyNowButton = `<a href="${response.data.buyNowUrl}" class="product-detail__details__shop-actions__buy-now__btn">Buy Now</a>`;

        // append the status flags
        $(`.${productModalClasses.flagContainer}`).html('');
        $(`.${productModalClasses.flagContainer}`).append(newFlag);
        $(`.${productModalClasses.flagContainer}`).append(saleFlag);
        $(`.${productModalClasses.flagContainer}`).append(soldOutFlag);


        // append the product image
        $(`.${productModalClasses.image}`).html('');
        $(`.${productModalClasses.image}`).append(response.data.productImage);

        // append product title
        $(`.${productModalClasses.title}`).html(response.data.productTitle);

        // append product size
        $(`.${productModalClasses.size}`).html('');
        $(`.${productModalClasses.size}`).append(response.data.productSize);

        // append the product pricing
        $(`.${productModalClasses.priceContainer}`).html('');
        $(`.${productModalClasses.priceContainer}`).append(salePrice);
        $(`.${productModalClasses.priceContainer}`).append(regularPrice);
        $(`.${productModalClasses.priceContainer}`).attr("data-original-regular-price",response.data.regularPrice);
        $(`.${productModalClasses.priceContainer}`).attr("data-original-sale-price",response.data.salePrice);

        // append the variable pricing dropdown
        if ($('.product-detail__details__shop-actions__variation--quickview-modal').length){
          $('.product-detail__details__shop-actions__variation--quickview-modal').remove();
        }
        $(`.${productModalClasses.shopActionsContainer}`).prepend(response.data.productVariationDropdown);

        /**
         * Hide addToBag and buyNowButton for pros 2020-10-22 per Trish's request
         */
        if (products.userRole != 'pro') {
          // append the CTA buttons (Add to Bag & Buy Now)

          if (response.data.isInStock) {
            $(`.${productModalClasses.addToBagContainer}`).html('');
            $(`.${productModalClasses.addToBagContainer}`).append(addToBagButton);
            $(`.${productModalClasses.buyNowContainer}`).html('');
            $(`.${productModalClasses.buyNowContainer}`).append(buyNowButton);
          } else {
            $('.product-detail__details__shop-actions__quantity').remove()
            $(`.${productModalClasses.addToBagContainer}`).html('');
            $(`.${productModalClasses.buyNowContainer}`).html('');
          }
        } else {
          $(`.${productModalClasses.description}`).after('<div class="alert alert-info" role="alert"><i class="fas fa-info-circle"></i> Please contact your Epionce representative for wholesale ordering.</div>');
          $('.product-detail__details__shop-actions__quantity').remove()
          $(`.${productModalClasses.addToBagContainer}`).html('');
          $(`.${productModalClasses.buyNowContainer}`).html('');
        }

        // append the description
        if (response.data.isInStock) {
          $(`.${productModalClasses.description}`).html(response.data.productDescription);
        } else {
          $(`.${productModalClasses.description}`).html(response.data.productDescription + '<br><h3 class="text-primary h5">Out of stock.</h3>');
        }

        // add the product detail page link
        $(`.${productModalClasses.viewAllDetailsLink}`).attr('href',response.data.productUrl);

        // remove loader and show the modal content
        $('#quickviewModal').find('.product-detail__wrapper--quickview-modal').removeClass('hidden');

        // if it's a pro wholesale user, remove the hidden class on the pro pricing table
        $('#productModalLoader').remove();

        // position the flags, if they are present
        const paddingLeft = 5;
        for (let i = 0; i <= badgeCount; i++) {
          if ( i === 0 ) {
            $(`#quickview-badge-${i}`).css({'top':'-1px', 'left':'15px'});
          } else {
            const prevLeft = parseInt($(`#quickview-badge-${i-1}`).css('left'));
            const prevWidth = parseInt($(`#quickview-badge-${i-1}`).outerWidth());
            $(`#quickview-badge-${i}`).css({'top':'-1px', 'left':`${prevLeft+prevWidth+paddingLeft}px;`, 'margin-right':'5px'});
          }
        }

        // See if there are variations and update links
        if ($('.product-detail__details__shop-actions__variation__select').length > 0) {
          const target = e.target || e.srcElement;
          const variationSelect = $(target);
          const selectedOption = variationSelect.find(':selected');
          const productId = variationSelect.attr('data-product-id');
          const variationId = selectedOption.val();
          const variationValue = selectedOption.attr('data-variation-encoded');
          const quantity = $('#number-spinner-input').val();

          // update the add to bag and buy now button urls dynamically
          $('.product-detail__details__shop-actions__add-to-bag__btn').attr('href',`/?add-to-cart=${productId}&variation_id=${variationId}&attribute_size=${variationValue}&quantity=${quantity}`);
          $('.product-detail__details__shop-actions__buy-now__btn').attr('href',`/shopping-bag/?add-to-cart=${productId}&variation_id=${variationId}&attribute_size=${variationValue}&quantity=${quantity}`);
        }
      });

      $promise.fail((jqXhr, textStatus, errorThrown) => {
        // console.log(jqXhr);
        // console.log(textStatus);
        // console.log(errorThrown);
      });
    });
    // event handler for qty +/- button presses
    $('#number-spinner-input').on('change', function(e){
      const quantity = $('#number-spinner-input').val();
      const productId = $('.product-detail__details__shop-actions__add-to-bag__btn').attr('data-product-id');
      
      if ($('.product-detail__details__shop-actions__variation__select').length > 0) {
        const variationSelect = $('.product-detail__details__shop-actions__variation__select');
        const selectedOption = variationSelect.find(':selected');
        const variationId = selectedOption.val();
        const variationValue = selectedOption.attr('data-variation-encoded');

        // update the add to bag and buy now button urls dynamically
        $('.product-detail__details__shop-actions__add-to-bag__btn').attr('href',`/?add-to-cart=${productId}&variation_id=${variationId}&attribute_size=${variationValue}&quantity=${quantity}`);
        $('.product-detail__details__shop-actions__buy-now__btn').attr('href',`/shopping-bag/?add-to-cart=${productId}&variation_id=${variationId}&attribute_size=${variationValue}&quantity=${quantity}`);
      } else {
        // update the add to bag and buy now button urls dynamically
        $('.product-detail__details__shop-actions__add-to-bag__btn').attr('href',`/?add-to-cart=${productId}&quantity=${quantity}`);
        $('.product-detail__details__shop-actions__buy-now__btn').attr('href',`/shopping-bag/?add-to-cart=${productId}&quantity=${quantity}`);
      }

      if (products.userRole === 'pro') {
        // wholesale pricing, which is the only pricing affected by qty changes
        if ($('.product-detail__details__shop-actions__variation__select').length) {
          // for products that have variations
          const variationSelect = $('.product-detail__details__shop-actions__variation__select');
          var isSale = variationSelect.attr('data-is-sale');
          const selectedOption = variationSelect.find(':selected');
          const variationValue = selectedOption.attr('data-variation-encoded');
          var regularPrice = parseFloat(selectedOption.attr('data-regular-price').substr(1));
          var salePrice = parseFloat(selectedOption.attr('data-price').substr(1));
          var qty = parseInt($(this).val());
          if (qty > 0 && qty < 12) {
            var proRegularPrice = (regularPrice-(regularPrice*0.50)).toFixed(2);
            var proSalePrice = (salePrice-(salePrice*0.50)).toFixed(2);
          } else if ((qty > 11) && (qty < 60)) {
            var proRegularPrice = (regularPrice-(regularPrice*0.55)).toFixed(2);
            var proSalePrice = (salePrice-(salePrice*0.55)).toFixed(2);
          } else {
            // greater than 60
            var proRegularPrice = (regularPrice-(regularPrice*0.575)).toFixed(2);
            var proSalePrice = (salePrice-(salePrice*0.575)).toFixed(2);
          }

          if (isSale === 'true') {
            $('.product-detail__details__price--quickview-modal').find('.sale-price').text(`$${proSalePrice}`);
          } else {
            $('.product-detail__details__price--quickview-modal').find('.regular-price').text(`$${proRegularPrice}`);
          }
        } else {
          // no variations for this product
          var regularPrice = parseFloat($('.product-detail__details__price--quickview-modal').attr("data-original-regular-price"));
          var salePrice = parseFloat($('.product-detail__details__price--quickview-modal').attr("data-original-sale-price"));
          var qty = $(this).val();
          if (qty > 0 && qty < 12) {
            var proRegularPrice = (regularPrice-(regularPrice*0.50)).toFixed(2);
            var proSalePrice = (salePrice-(salePrice*0.50)).toFixed(2);
          } else if ((11 < qty) && (qty < 60)) {
            var proRegularPrice = (regularPrice-(regularPrice*0.55)).toFixed(2);
            var proSalePrice = (salePrice-(salePrice*0.55)).toFixed(2);
          } else {
            // greater than 60
            var proRegularPrice = (regularPrice-(regularPrice*0.575)).toFixed(2);
            var proSalePrice = (salePrice-(salePrice*0.575)).toFixed(2);
          }

          if (isSale === 'true') {
            $('.product-detail__details__price--quickview-modal').find('.sale-price').text(`$${proSalePrice}`);
          } else {
            $('.product-detail__details__price--quickview-modal').find('.regular-price').text(`$${proRegularPrice}`);
          }
        }
      }
    });

    // event handler for qty input field changes
    $('.product-detail__details__shop-actions__quantity__number-spinner').on('click','.input-group-btn',e => {
      $('#number-spinner-input').trigger('change');
    });

    // event handler for variation select dropdown changes
    $('.product-detail__details__shop-actions.quickview-modal').on('change', '.product-detail__details__shop-actions__variation--quickview-modal', e => {
      const target = e.target || e.srcElement;
      const variationSelect = $(target);
      const isSale = variationSelect.attr('data-is-sale');
      const selectedOption = variationSelect.find(':selected');
      const productId = $('.product-detail__details__shop-actions__add-to-bag__btn').attr('data-product-id');
      const quantity = $('#number-spinner-input').val();
      const variationId = selectedOption.val();
      const variationValue = selectedOption.attr('data-variation-encoded');
      const regularPrice = parseFloat(selectedOption.attr('data-regular-price').substr(1));
      const salePrice = parseFloat(selectedOption.attr('data-price').substr(1));

      const regularPriceTier1 = regularPrice-(regularPrice*0.50);
      const regularPriceTier2 = regularPrice-(regularPrice*0.55);
      const regularPriceTier3 = regularPrice-(regularPrice*0.575);

      const salePriceTier1 = salePrice-(salePrice*0.575);
      const salePriceTier2 = salePrice-(salePrice*0.575);
      const salePriceTier3 = salePrice-(salePrice*0.575);

      if (products.userRole === 'pro') {
        const qty = parseFloat($('#number-spinner-input').val());
        if (qty == 0 || ((qty > 0) && (qty < 12))) {
          var proRegularPriceMain = (regularPrice-(regularPrice*0.50));
          var proSalePriceMain = (salePrice-(salePrice*0.50));
        } else if ((qty > 11) && (qty < 60)) {
          var proRegularPriceMain = (regularPrice-(regularPrice*0.55));
          var proSalePriceMain = (salePrice-(salePrice*0.55));
        } else {
          // qty > 59
          var proRegularPriceMain = (regularPrice-(regularPrice*0.575));
          var proSalePriceMain = (salePrice-(salePrice*0.575));
        }

        if (isSale === 'true') {
          $('.sale-price').text(`$${proSalePriceMain.toFixed(2)}`);
          $('.regular-price').text(`$${proRegularPriceMain.toFixed(2)}`);

          // apply the price tiers to the price tier table
          $('#pro-price-tier-1').html(`$${salePriceTier1.toFixed(2)}`);
          $('#pro-price-tier-2').html(`$${salePriceTier2.toFixed(2)}`);
          $('#pro-price-tier-3').html(`$${salePriceTier3.toFixed(2)}`);
        } else {
          $('.regular-price').text(`$${proRegularPriceMain.toFixed(2)}`);

          // apply the price tiers to the price tier table
          $('#pro-price-tier-1').html(`$${regularPriceTier1.toFixed(2)}`);
          $('#pro-price-tier-2').html(`$${regularPriceTier2.toFixed(2)}`);
          $('#pro-price-tier-3').html(`$${regularPriceTier3.toFixed(2)}`);
        }
      } else {
        // end user pricing
        if (isSale === 'true') {
          $('.sale-price').text(`$${salePrice.toFixed(2)}`);
          $('.regular-price').text(`$${regularPrice.toFixed(2)}`);
        } else {
          $('.regular-price').text(`$${regularPrice.toFixed(2)}`);
        }
      }

      // update the add to bag and buy now button urls dynamically
      $('.product-detail__details__shop-actions__add-to-bag__btn').attr('href',`/?add-to-cart=${productId}&variation_id=${variationId}&attribute_size=${variationValue}&quantity=${quantity}`);
      $('.product-detail__details__shop-actions__buy-now__btn').attr('href',`/shopping-bag/?add-to-cart=${productId}&variation_id=${variationId}&attribute_size=${variationValue}&quantity=${quantity}`);
    });

    // event handler for the Add to Bag button click
    $('#quickviewModal').on('click', '.product-detail__details__shop-actions__add-to-bag__btn', e => {
      e.preventDefault();
      const target = e.target || e.srcElement;
      const variationSelect = $('.product-detail__details__shop-actions__variation__select');
      const selectedOption = variationSelect.find(':selected');
      var variationId = null;
      var variations = [];

      if (variationSelect.length > 0) {
        var variationId = selectedOption.val();
        var variations = {
          'Size': selectedOption.text()
        };
      };

      const jsonData = {
        'productId': $(target).attr('data-product-id'),
        'quantity': $('#quickviewModal #number-spinner-input').val(),
        'variationId': variationId,
        'variation': variations
      };

      if (products.userRole == 'pro') {
        // wholesale customer, temporarily deny Add to Bag functionality
        $('#wholesale-notification-modal').modal('show');
      } else {
        // regular customer, allow AJAX Add to Bag functionality
        $(target).html('<i class="far fa-spinner fa-pulse"></i>');
        const $promise = $.ajax({
          url: products.ajaxUrl,
          method: 'post',
          dataType: 'json',
          data: {'json': jsonData, 'security': products.nonce, 'action': 'addToBagQuickview'}
        });

        $promise.done((response, textStatus, jqXhr) => {
          if (response.status === 'success') {
            $(target).html('Added!');
            const currentShoppingBagTotal = parseInt($('.main-nav-shopping-cart-button>a').text());
            $('.main-nav-shopping-cart-button > a').html(currentShoppingBagTotal+parseInt(response.data.quantityAdded));
            $('.header__mobile-menu__list-item.shopping-cart-button>a').html(currentShoppingBagTotal+parseInt(response.data.quantityAdded));
            setTimeout(() => {
              $(target).html('Add to Bag');
            },1000);
          }
        });

        $promise.fail((jqXhr, textStatus, errorThrown) => {
          // console.log(jqXhr);
          // console.log(textStatus);
          // console.log(errorThrown);
        });
      }
    });
  },
  finalize() {
    // JavaScript to be fired on all pages, after page specific JS is fired
    // Place this in the finalize section
    $(window).load(() => {
      // Target your element
      // if ($('.masthead__wrapper').length > 0) {
      //   $('.masthead__wrapper').colorBrightness();
      // }
    });

    // attach handler for footer MailChimp list signup for checkbox
    if ($('#mc_embed_signup').length) {
      // $('#mailchimp-wholesale-list-checkbox').on('change',function(e){
      //   var isChecked = $(this).is(':checked');
      //   var mcUsernumber = 'd492d067001de437edfbeb11a';
      //   var regMailingListId = '357ce4c1f2';
      //   var regMailingName = 'b_d492d067001de437edfbeb11a_357ce4c1f2';
      //   var wholesaleMailingListId = 'f8c45fa2f5';
      //   var wholesaleMailingName = 'b_d492d067001de437edfbeb11a_f8c45fa2f5';
      //   var action = '';
      //   if (isChecked) {
      //     action = "//epionce.us1.list-manage.com/subscribe/post?u="+mcUsernumber+"&amp;id="+wholesaleMailingListId;
      //     $('#mc-embedded-subscribe-form').attr('action',action);
      //     $('#bot-block-input').attr('name',wholesaleMailingName);
      //   } else {
      //     action = "//epionce.us1.list-manage.com/subscribe/post?u="+mcUsernumber+"&amp;id="+regMailingListId;
      //     $('#mc-embedded-subscribe-form').attr('action',action);
      //     $('#bot-block-input').attr('name',regMailingName);
      //   }
      // });
    }
  },
};



// WEBPACK FOOTER //
// ./scripts/routes/common.js